import { Helper } from '../../js/helpers/Helper';

/**
 * MegamenuAjaxSearch Class
 */
class MegamenuAjaxSearch {

	/**
	 * Constructor
	 *
	 * @param {node} block
	 * @return {void}
	 */
	constructor( block ) {

		this.block = block;

		if ( ! this.block ) {

			return false;

		}

		//	this.breakpoint = 1110; //1240//859;//1110; //1025;//768;
		this.breakpointSmallMobile = 1240;

		//this.mediaQuery = window.matchMedia( `(min-width:${ this.breakpoint }px)` );
		this.mediaQuerySmallMobile = window.matchMedia( `(max-width:${ this.breakpointSmallMobile }px)` );

		this.search = block.querySelector( '.js-search' );
		this.parentSearchToggle = block.querySelector( '.b-megamenu-search__toggle' );

		this.searchToggle = block.querySelector( '.js-search-toggle' );
		this.searchContainer = block.querySelector( '.js-search-container' );
		this.searchInput = block.querySelector( '.js-search-input' );
		this.megamenu =  this.block.closest( '.b-megamenu' );
		this.megamenuContainer =  this.block.closest( '.b-megamenu__container' );

		this.addEvents();

	}


	/**
	 * Add Events
	 *
	 * @return {void}
	 */
	addEvents() {


		this.searchToggle.addEventListener( 'click', this.clickedHandler );
		this.searchToggle.addEventListener( 'keyup', this.keyupHandler )
		this.searchToggle.addEventListener( 'focusout', this.resetFocus );

		this.searchInput.addEventListener( 'focus', this.focusInputHandler )
		this.searchInput.addEventListener( 'blur', this.focusInputHandler )

		const ro = new ResizeObserver( ( entries ) => {

			for ( const entry of entries ) {

				this.updateTopBar( entry )


			}

		} );

		ro.observe( this.megamenuContainer );

	}




	/**
	 * updateTopBar
	 *
	 * @param {element} entry
	 * @return {void}
	 */
	updateTopBar( entry ) {

		this.searchContainer.style.width = `${  entry.contentRect.width  }px`;
		this.closeBar()

		if ( this.mediaQuerySmallMobile.matches ) {

			this.block.style.position='inherit';
			this.searchContainer.style.maxWidth = `unset`;
			this.searchContainer.style.right = null;
			this.searchContainer.style.left=0;

		} else {

			this.block.style.removeProperty( 'position' );
			this.searchContainer.style.removeProperty( 'max-width' );
			this.searchContainer.style.removeProperty( 'right' );
			this.searchContainer.style.removeProperty( 'left' );

		}

	}

	/**
	 * showBar
	 *
	 * @return {void}
	 */
	showBar( ) {

		this.searchContainer.classList.add( 'js-header-searchbar--opened' );
		this.searchContainer.classList.toggle( 'is-active' );
		this.parentSearchToggle.classList.toggle(  'is-dropdown--open' );
		this.megamenu.style.overflow = 'visible';

	}

	/**
	 * closeBar
	 *
	 * @return {void}
	 */
	closeBar( ) {


		Helper.removeClassFromEl( this.searchContainer, 'is-active' );
		Helper.removeClassFromEl( this.parentSearchToggle, 'is-dropdown--open' );
		this.searchContainer.classList.remove( 'js-header-searchbar--opened' );

	}



	/**
	 * clickedHandler
	 */
	clickedHandler = () => {

		if( this.searchContainer && this.searchInput ){

			this.showBar();
			this.searchInput.focus();

		}


	}

	/**
	 * keyupHandler
	 * @param {object} e
	 */
	keyupHandler = ( e ) => {

		this.resetFocus();
		Helper.addClassToEl( e.target.parentNode, 'js-focus' );


	}

	/**
	 * resetFocus
	 *
	 * @return {void}
	 */
	resetFocus = ( ) => {

		Helper.removeClassFromEl( this.searchToggle.parentNode, 'js-focus' );

	}

	/**
	 * focusInputHandler
	 * @param {object} e
	 * @return {void}
	 */
	focusInputHandler = ( e ) => {

		if ( e.type === 'focus' ){

			this.searchInput.closest( '.js-search' ).classList.add( 'is-active' );

		}
		if ( e.type === 'blur' ){

			this.searchInput.closest( '.js-search' ).classList.remove( 'is-active' );

		}

	}

}
document.querySelectorAll( '.b-megamenu-search' ).forEach( ( block ) => {

	new MegamenuAjaxSearch( block );

} )
